import { Button } from '@mui/material';
import { Chain } from '@ankr.com/chains-list';

import { useDialog } from 'modules/common/hooks/useDialog';
import { useHasCodeExample } from 'modules/chains/hooks/useHasCodeExample';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { CodeExampleModal } from '../CodeExampleModal';
import { codeExampleButtonTranslation } from './translation';
import { useCodeExampleButtonStyles } from './useCodeExampleButtonStyles';

interface CodeExampleButtonProps {
  chain: Chain;
  onOpen?: () => Promise<void>;
}

export const CodeExampleButton = ({
  chain,
  onOpen,
}: CodeExampleButtonProps) => {
  const {
    isOpened: isCodeExampleDialogOpened,
    onClose: closeCodeExampleDialog,
    onOpen: openCodeExampleDialog,
  } = useDialog();

  const hasCodeExample = useHasCodeExample(chain);

  const { keys, t } = useTranslation(codeExampleButtonTranslation);

  const { classes } = useCodeExampleButtonStyles();

  if (!hasCodeExample) {
    return null;
  }

  const onClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    await onOpen?.();

    openCodeExampleDialog();
  };

  return (
    <>
      <Button
        className={classes.root}
        onClick={onClick}
        size="small"
        variant="outlined"
      >
        {t(keys.codeExample)}
      </Button>
      <CodeExampleModal
        chain={chain}
        isOpenedCodeExample={isCodeExampleDialogOpened}
        onCloseCodeExample={closeCodeExampleDialog}
      />
    </>
  );
};
